export default __webpack_public_path__ + "static/media/WNo.8-7.4ad482bf.jpg";